export const memberApplicationRoutes = {
  member_application: {
    succesfull: '/member-application/application-successfull',
    enter_otp: '/member-application/enter-otp',
    member_application: '/member-application/application-form',
    get_started: '/member-application/get-started',
    resume_application: '/member-application/resume-application',
    pending_application: {
      index: '/member-application/pending-application/index',
      enter_otp: '/member-application/pending-application/enter-otp',
      edit_member: '/member-application/pending-application/edit-member',
      add_dependent: '/member-application/pending-application/add-dependent',
      edit_dependent: '/member-application/pending-application/edit-dependent',
      declare_and_submit: '/member-application/pending-application/declare-and-submit',
      set_account_password: '/member-application/pending-application/set-password',
      application_submitted: '/member-application/pending-application/application-submitted',
      cannot_resume: '/member-application/pending-application/cannot-resume',
    },
  },
};
